const useMileageOptionsLogic = () => {
  const apiRoute = "mileageoptions";
  const onlyForm = undefined;

  const initFields = [
    {
      name: "name",
      label: "Mileage option name",
      type: "text",
      isRequired: true,
      err: "Mileage option name is required",
      disableEditForNonAdmin: true,
    },
    {
      name: "daily_km_limit",
      label: "Daily Km limit",
      type: "number",
      minValue: 0,
      isRequired: true,
      err: "Daily Km limit is required",
    },
    {
      name: "weekly_km_limit",
      label: "Weekly Km limit",
      type: "number",
      minValue: 0,
      isRequired: true,
      err: "Weekly Km limit is required",
    },
    {
      name: "monthly_km_limit",
      label: "Monthly Km limit",
      type: "number",
      minValue: 0,
      isRequired: true,
      err: "Monthly Km limit is required",
    },
    {
      name: "extrakm_rate_ratio",
      label: "Daily rate multiplier",
      type: "number",
      minValue: 0,
      maxValue: 1,
      decimalCount: 3,
      isRequired: true,
      err: "Daily rate multiplier is required",
    },
    {
      name: "weekly_km_ratio",
      label: "Weekly rate multiplier",
      type: "number",
      minValue: 0,
      decimalCount: 3,
      isRequired: true,
      err: "Weekly rate multiplier is required",
    },
    {
      name: "monthly_km_ratio",
      label: "Monthly rate multiplier",
      type: "number",
      minValue: 0,
      decimalCount: 3,
      isRequired: true,
      err: "Monthly rate multiplier is required",
    },
    {
      name: "allow_frontend",
      label: "Show on frontend?",
      type: "toggle",
      isRequired: false,
      err: "Show on frontend? is required",
    },
    {
      name: "days_to_show",
      label: "Days to show on frontend",
      type: "number",
      minValue: 0,
      err: "Days to show is required",
    },
    // Add more fields as needed
  ];

  //Roles
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  const financeRole = process.env.REACT_APP_FINANCE_ROLE;
  const managerRole = process.env.REACT_APP_MANAGER_ROLE;
  ///Add,Delete,Edit Roles
  const addRoles = [admin, financeRole, managerRole];
  const deleteRoles = [admin, financeRole, managerRole];
  const editRoles = [admin, financeRole, managerRole];

  const getPromises = (temp) => {
    return [];
  };

  return {
    apiRoute,
    addRoles,
    editRoles,
    deleteRoles,
    initFields,
    onlyForm,
    getPromises,
  };
};

export default useMileageOptionsLogic;
